import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { getYoutubeId, isYoutube } from '../../utils';
import UrlEmbed from '../UrlEmbed';
import { deleteItem } from '../../utils/Network';

const DEFAULT_THUMB = '/assets/images/default.png';

export default function EpisodeGalleryCard({ item, showDelete, onAfterDelete }) {
  const [modalOpen, setModalOpen] = useState(false);

  const closeModal = () => setModalOpen(false);

  useEffect(() => {
    if (!modalOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [modalOpen]);

  const handleDelete = () => {
    deleteItem('api/coursehistorygallery', item.id);
    closeModal();
    if (onAfterDelete) onAfterDelete();
  };

  const thumbSrc =
    item?.url && isYoutube(item.url)
      ? `https://img.youtube.com/vi/${getYoutubeId(item.url)}/0.jpg`
      : DEFAULT_THUMB;

  const dateStr =
    item?.created_at && typeof item.created_at === 'string'
      ? item.created_at.split('T')[0]
      : '';

  return (
    <>
      <Modal
        closeTimeoutMS={500}
        isOpen={modalOpen}
        onRequestClose={closeModal}
        className="Modal Modal--episode-gallery"
        overlayClassName="Overlay"
      >
        <div className="modal-content">
          <div className="modal-header modal-header--episode-gallery">
            <button type="button" className="close" onClick={closeModal} aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body modal-body--episode-gallery text-center">
            {item?.url && item.url !== 'undefined' && <UrlEmbed url={item.url} />}
          </div>
        </div>
      </Modal>

      <div className="talent-card episode-gallery-card">
        {showDelete && (
          <button
            type="button"
            className="btn btn-cm btn-xs episode-gallery-card__delete"
            title="Delete"
            onClick={(e) => {
              e.stopPropagation();
              if (window.confirm('Are you sure you wish to delete this item?')) handleDelete();
            }}
          >
            <i className="fa fa-trash" />
          </button>
        )}
        <button
          type="button"
          className="episode-gallery-card__open"
          onClick={() => setModalOpen(true)}
        >
          <div className="episode-gallery-card__thumb-wrap">
            <img className="episode-gallery-card__thumb" src={thumbSrc} alt="" />
            <span className="episode-gallery-card__play" aria-hidden>
              <i className="fa fa-play" />
            </span>
          </div>
          <div className="talent-card-name episode-gallery-card__title">
            E{item?.episode ?? '—'}
          </div>
          {dateStr ? (
            <span className="talent-card-count episode-gallery-card__meta">
              <i className="fa fa-calendar-o" />
              {dateStr}
            </span>
          ) : null}
        </button>
      </div>
    </>
  );
}
